import { render } from "./App.vue?vue&type=template&id=36c2ab6b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=36c2ab6b&lang=css"

import exportComponent from "C:\\Users\\raubart\\Desktop\\loop\\hyundai_shop\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__